<!-- www.quickepay / Pricing
Edited with WebStorm
Created by maizerg on 2/20/18 at 1:46 PM
<!-->

<template>
    <div id="bus-pricing">
        <quick-site-bread-crumb title="Preçário"/>
        <quick-pricing-area/>
    </div>
</template>

<script>
import QuickPricingArea from '../../components/pricingArea'
import QuickSiteBreadCrumb from '../../components/site/SiteBreadCrumb'

export default {
  components: {
    QuickSiteBreadCrumb,
    QuickPricingArea
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/business/Pricing.vue